import { useEffect } from 'react';

import { di } from 'react-magnetic-di';
import { useQueryParam } from 'react-resource-router-next';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';

export type HandoffType = 'agent' | 'app' | 'automation';

// All ids that were already triggered. This is outside react lifecycle to ensure it's not reset on re-render, which could cause duplicate events.
const _ids: Set<string> = new Set();
const hasBeenTriggered = (id: string) => {
	return _ids.has(id);
};
const markAsTriggered = (id: string) => {
	_ids.add(id);
};

export const useSaHandoffTracker = (handoffType: HandoffType): void => {
	di(useAnalyticsEvents, useQueryParam);

	const [saHandoff, setSaHandoff] = useQueryParam('saHandoff');
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		if (fg('remove_handoff_duplications')) {
			if (!saHandoff || hasBeenTriggered(saHandoff)) {
				return;
			}
		} else if (saHandoff !== 'true') {
			return;
		}

		// Mark as triggered straight away to prevent duplicates
		fg('remove_handoff_duplications') && markAsTriggered(saHandoff);

		// Clear the query param after tracking to avoid duplicate events
		setSaHandoff(undefined, 'replace');

		// Fire analytics event for successful handoff landing
		fireTrackAnalytics(createAnalyticsEvent({}), 'solutionArchitectHandoff success', {
			name: handoffType,
		});
	}, [saHandoff, setSaHandoff, handoffType, createAnalyticsEvent]);
};
